(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-unsubscribe"]) return;
  try {
    
  (function () {
    function onReady(fn) {
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
      else fn();
    }

    function decodeHtml(value) {
      var textarea = document.createElement('textarea');
      textarea.innerHTML = String(value || '');
      return textarea.value;
    }

    function readCopy() {
      var el = document.querySelector('[data-unsubscribe-copy]');
      if (!el) return {};
      try {
        var parsed = JSON.parse(el.textContent || '{}');
        Object.keys(parsed).forEach(function (key) {
          parsed[key] = decodeHtml(parsed[key]);
        });
        return parsed;
      } catch (e) {
        return {};
      }
    }

    function isValidEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
    }

    function emailFromUrl() {
      try {
        var params = new URLSearchParams(window.location.search);
        return String(params.get('email') || params.get('e') || '').trim();
      } catch (e) {
        return '';
      }
    }

    function setStatus(el, message, isError) {
      if (!el) return;
      el.textContent = message || '';
      el.hidden = !message;
      el.classList.toggle('is-error', !!isError);
    }

    onReady(function () {
      var root = document.querySelector('[data-unsubscribe-root]');
      if (!root) return;

      var copy = readCopy();
      var form = root.querySelector('[data-unsubscribe-form]');
      var emailInput = root.querySelector('[data-unsubscribe-email]');
      var submitBtn = root.querySelector('[data-unsubscribe-submit]');
      var introEl = root.querySelector('[data-unsubscribe-intro]');
      var statusEl = root.querySelector('[data-unsubscribe-status]');
      var apiUrl = String(root.getAttribute('data-api-url') || '').trim() || 'https://kasuri-unsubscribe.vercel.app/api/unsubscribe';
      var initialEmail = emailFromUrl();

      if (emailInput && initialEmail) {
        emailInput.value = initialEmail;
      }

      if (introEl) {
        if (initialEmail && copy.intro) {
          introEl.textContent = String(copy.intro).replace(/__EMAIL__/g, initialEmail);
        } else if (copy.introGeneric) {
          introEl.textContent = copy.introGeneric;
        }
      }

      if (!form || !emailInput || !submitBtn) return;

      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var email = String(emailInput.value || '').trim();
        if (!email) {
          setStatus(statusEl, copy.missingEmail || 'Enter an email address.', true);
          emailInput.focus();
          return;
        }
        if (!isValidEmail(email)) {
          setStatus(statusEl, copy.invalidEmail || 'Please enter a valid email address.', true);
          emailInput.focus();
          return;
        }

        var defaultLabel = submitBtn.textContent;
        submitBtn.disabled = true;
        submitBtn.textContent = copy.working || 'Please wait…';
        setStatus(statusEl, '', false);

        var endpoint = apiUrl;
        try {
          var parsed = new URL(apiUrl, window.location.origin);
          parsed.searchParams.set('email', email);
          endpoint = parsed.toString();
        } catch (e) {
          endpoint = apiUrl;
        }

        fetch(endpoint, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ email: email }),
        })
          .then(function (res) {
            return res
              .json()
              .catch(function () {
                return {};
              })
              .then(function (data) {
                return { ok: res.ok && data.ok !== false, data: data };
              });
          })
          .then(function (result) {
            if (!result.ok) {
              throw new Error((result.data && result.data.error) || 'unsubscribe_failed');
            }
            root.classList.add('is-done');
            if (introEl) introEl.hidden = true;
            setStatus(statusEl, copy.success || "You've been unsubscribed.", false);
          })
          .catch(function () {
            setStatus(statusEl, copy.error || 'Something went wrong. Please try again.', true);
            submitBtn.disabled = false;
            submitBtn.textContent = defaultLabel || copy.button || 'Unsubscribe';
          });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
